import React from "react";
import ChrMetricContainer from "../../Basic/Metric/ChrMetricContainer";
import ChrMetricTitle from "../../Basic/Metric/ChrMetricTitle";
import ChrMetricValue from "../../Basic/Metric/ChrMetricValue";
import { metricType } from "../../constants";
import ChrAlert from "../../Basic/Metric/ChrAlert";

/*
props = {
  name: <string>,
  data: { value: <string> },
  url: <string>
}
*/


const ChrSubMetric = (props) => {
  const { name, data: { value, formattedValue, alert = {} }, url, helpText, eventDetails } = props;

  return (
    <ChrMetricContainer className='mr-3 cui-min-width-50'>
      <ChrMetricTitle type={ metricType.SUBMETRIC } helpText={ helpText }>
        { name }
      </ChrMetricTitle>
      <div className="d-flex flex-gap-5 align-items-center">
        <ChrMetricValue type={ metricType.SUBMETRIC } url={ url } eventDetails={ eventDetails } formattedValue={ formattedValue }>
          { value }
        </ChrMetricValue>
        <ChrAlert {...alert} containerLocator="#cjs-management-report-v2" className="pr-2" additionalIconClass="fa-sm"/>
      </div>
    </ChrMetricContainer>
  )
}

export default ChrSubMetric
